import {
	ASSIGNEE_TYPE,
	DUE_DATE_TYPE,
	ISSUE_KEY_TYPE,
	SUMMARY_TYPE,
} from '@atlassian/jira-platform-field-config';
import {
	BOARD_FIELD_DATE,
	BOARD_FIELD_LABEL,
	BOARD_FIELD_ISSUE_TYPE,
	BOARD_FIELD_PRIORITY,
	BOARD_FIELD_STATUS,
	BOARD_FIELD_TEXT,
	BOARD_FIELD_USER,
} from '../../common/constants';
import type { BoardIssueFieldOld } from '../../common/types';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const getIssueFromIssueFieldsOld = (issueId: number, issueFields: BoardIssueFieldOld[]) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const issue: any = {
		assigneeKey: null,
		assigneeName: null,
		dueDate: null,
		id: issueId,
		key: '',
		needsExtendedFieldsUpdate: false,
		statusId: 0,
		subtaskMetadata: {
			done: 0,
			total: 0,
		},
		summary: '',
		url: '',
		issueTypeId: '',
	};

	issueFields.forEach((field) => {
		switch (field.type) {
			case BOARD_FIELD_DATE:
				if (field.fieldId === DUE_DATE_TYPE) {
					issue.dueDate = field.value;
				}
				break;
			case BOARD_FIELD_LABEL:
				issue.labels = field.value;
				break;
			case BOARD_FIELD_ISSUE_TYPE:
				issue.issueTypeId = field.id;
				break;
			case BOARD_FIELD_PRIORITY:
				issue.priorityIconUrl = field.priority.iconUrl;
				issue.priorityId = field.priority.id;
				issue.priorityName = field.priority.name;
				break;
			case BOARD_FIELD_STATUS:
				issue.statusCategory = field.status.category;
				issue.statusId = field.status.id;
				issue.statusName = field.status.name;
				break;
			case BOARD_FIELD_TEXT:
				if (field.fieldId === ISSUE_KEY_TYPE) {
					issue.key = field.value;
				} else if (field.fieldId === SUMMARY_TYPE) {
					issue.summary = field.value;
				}
				break;
			case BOARD_FIELD_USER:
				if (field.fieldId === ASSIGNEE_TYPE) {
					issue.assigneeKey = field.users[0].accountId;
					issue.assigneeName = field.users[0].name;
					issue.assignee = {
						avatarUrl: field.users[0].avatarURL ?? '',
						displayName: field.users[0].name,
					};
				}
				break;

			default:
				break;
		}
	});

	return issue;
};
